export const HeroSpotlight = [
  {
    imageSrc:
      "https://vitalforceassets.s3.amazonaws.com/clean-cult-founders.jpg",
    name: "Ryan Lupberger",
    company: "Cleancult",
    description:
      "One day, during a particularly powerful spin cycle, our co-founder Ryan, noticed there were no recognizable ingredients listed on his bottle of detergent. You heard us, not one. Intrigued, he did some digging and was shocked to learn of all the artificial chemicals in conventional cleaners, natural alternatives weren’t much better either, with their toxic plastic packaging, indecipherable ingredients, and let’s face it, weak results.",
  },
  {
    imageSrc:
      "https://vitalforceassets.s3.amazonaws.com/620ae150568f3f385d0bb577_STC+Headshots.png",
    name: "Jordan Nathan",
    company: "Caraway",
    description: `We’re on a mission to craft well-designed home goods that thoughtfully raise the standards of what you cook with. Simply put, our products are designed to make your life easier and healthier.`,
  },
  {
    imageSrc:
      "https://vitalforceassets.s3.amazonaws.com/META_blog_founderama.jpg",
    name: "Simon Enver",
    company: "Quip",
    description:
      'Our journey began at a neighborhood dentist in New York, with a suggestion to use the “cheapest electric brush available” to fight the common, damaging habit of brushing too hard. Years of "innovation" had barely improved the humble toothbrush, and instead, overshadowed the far more harmful, habitual problems that still persist.',
  },
];

export const founders = [
  {
    image: "https://vitalforceassets.s3.amazonaws.com/clean-cult-founders.jpg",
    name: "Ryan Lupberger",
    company: "Cleancult",
  },
  {
    image:
      "https://vitalforceassets.s3.amazonaws.com/620ae150568f3f385d0bb577_STC+Headshots.png",
    name: "Jordan Nathan",
    company: "Caraway",
  },
  {
    image:
      "https://vitalforceassets.s3.amazonaws.com/Screen+Shot+2023-11-12+at+3.28.40+PM.png",
    name: "Simon Enver",
    company: "Quip",
  },
  {
    image:
      "https://vitalforceassets.s3.amazonaws.com/AllisonandAdamGrossman.jpg",
    name: "Allison & Adam Goldman",
    company: "Seaweed Bath Co.",
  },

  {
    image:
      "https://vitalforceassets.s3.amazonaws.com/Bahiri-Mark-headshot-mu7pzg5um6auw1y7709vmksji62olb7l28ceoegjdk.jpg",
    name: "Mark Bahiri",
    company: "Emerald Creek Capital",
  },

  {
    image: "https://vitalforceassets.s3.amazonaws.com/Brian+Vengo.jpeg",
    name: "Brian Shimmerlik",
    company: "Vengo",
  },

  {
    image:
      "https://vitalforceassets.s3.amazonaws.com/Brutus+broth+founders.jpg",
    name: "Kim Hehir & Sue Delegan ",
    company: "Brutus Broth",
  },
  {
    image: "https://vitalforceassets.s3.amazonaws.com/collin.png",
    name: "Collin Eckles",
    company: "Natureza",
  },
  {
    image: "https://vitalforceassets.s3.amazonaws.com/Culture+founder.jpeg",
    name: "Thomas Moffitt",
    company: "Culture Fresh Foods",
  },
  {
    image: "https://vitalforceassets.s3.amazonaws.com/david+gale.jpg",
    name: "David Gale",
    company: "We Are the Mighty",
  },
  {
    image: "https://vitalforceassets.s3.amazonaws.com/Fernando-1.png",
    name: "Fernando Gentil",
    company: "Natureza",
  },
  {
    image: "https://vitalforceassets.s3.amazonaws.com/JaseTrace.png",
    name: "Sarah Mullins",
    company: "Buchi",
  },
  {
    image: "https://vitalforceassets.s3.amazonaws.com/Joe.png",
    name: "Joe Tonnos",
    company: "Natureza",
  },
  {
    image: "https://vitalforceassets.s3.amazonaws.com/Wink+coffee+founder.jpg",
    name: "Jayson Rapaport",
    company: "Wink Coffee",
  },
];

export const Projects = [
  {
    name: "Quip",
    image: "/logos/quip.png",
    websiteUrl: "https://www.getquip.com",
    companyType: "Consumer goods",
    founder: "Simon Enver",
    founderUrl: "https://www.linkedin.com/in/simonenever/",
    description:
      "Everyone’s got a mouth, and a healthy mouth is the gateway to a healthier you. So we strive to bring delight to your daily routine and help you guide good habits from morning refresh to bedtime brushing.",
  },
  {
    name: "Caraway",
    image: "/logos/caraway.png",
    websiteUrl: "https://www.carawayhome.com",
    companyType: "Manufacturing",
    founder: "Jordan Nathan",
    founderUrl: "https://www.linkedin.com/in/jordannathanprofile/",
    description:
      "We’re on a mission to craft well-designed, non-toxic ceramic cookware that thoughtfully raises the standards of what you cook with.",
  },
  {
    name: "Buchi",
    image: "/logos/buchi.png",
    websiteUrl: "https://www.drinkbuchi.com",
    companyType: "Food & Beverage Manufacturing",
    founder: "Sarah Mullins",
    founderUrl: "https://www.linkedin.com/in/sarah-mullins-61279245/",
    description:
      "Our purpose is to craft delicious, high-quality, functional beverages, invest in the regeneration of our planet, and use business as a conduit for positive social impact.",
  },
  {
    name: "Vengo",
    image: "/logos/vengo.png",
    websiteUrl: "https://vengolabs.com/product/",
    companyType: "Media & Telecom",
    founder: "Brian Shimmerlik",
    founderUrl: "https://www.linkedin.com/in/brian-shimmerlik-19293813/",
    description:
      "See how far screens can go. Vengo enables media buyers to efficiently access target audiences at scale by connecting DOOH screens to programmatic channels through a turnkey technology and programmatic sales platform.",
  },
  {
    name: "Better Bites",
    image: "/logos/better-bites.png",
    websiteUrl: "https://betterbitesbakery.com",
    companyType: "Food & Beverage Manufacturing",
    founder: "Leah Lopez",
    founderUrl: "https://www.linkedin.com/in/simonenever/",
    description:
      "GLUTEN-FREE. DAIRY-FREE. PEANUT-FREE. TREE NUT-FREE. EGG-FREE. SOY-FREE. FISH-FREE. SHELLFISH-FREE. SESAME-FREE",
  },
  {
    name: "Brutus Broth",
    image: "/logos/brutus-broth.png",
    websiteUrl: "https://brutusbroth.com",
    companyType: "Pet Services",
    founder: "Kimberly Hehir",
    founderUrl: "https://www.linkedin.com/in/kimberly-hehir-6753391/",
    description:
      "Brutus Broth offers a variety of all-natural food products for dogs. Fortified with turmeric, glucosamine and chondroitin, Brutus Broth offers human-grade products that are gluten, soy, yeast and dairy-free and has no artificial flavors, preservatives or colors.",
  },

  {
    name: "Clean Cult",
    image: "/logos/clean-cult.png",
    websiteUrl: "https://www.cleancult.com",
    companyType: "Manufacturing",
    founder: "Ryan Lupberger",
    founderUrl: "https://www.linkedin.com/in/ryanlupberger/",
    description:
      "On a mission to create a cleaner kind of cult that helps people switch from a bad plastic habit to a cleaner refill ritual.",
  },

  {
    name: "Culture Fresh Foods",
    image: "/logos/culture-fresh-foods.png",
    websiteUrl: "https://www.culturefreshfoods.com",
    companyType: "Food Production",
    founder: "Thomas Moffitt",
    founderUrl: "https://www.linkedin.com/in/thomas-moffitt-0425414/",
    description:
      "Culture Fresh Foods® is a 100% plant-based dairy alternative company based in Naugatuck, CT. We produce cultured plant-based spoonables and spreadables which include yogurts, sour cream, dips ,pudding, cream cheese, butters and ice cream mix.",
  },
  {
    name: "Emerald Creek Capital",
    image: "/logos/emerald-creek-capital.png",
    websiteUrl: "https://emeraldcreekcapital.com",
    // Was "Consumer goods", which filed a real-estate lender under CPG.
    companyType: "Investment & Advisory",
    founder: "Mark Bahiri",
    founderUrl: "https://www.linkedin.com/in/emeraldcreek/",
    description:
      "With offices in Manhattan, Boston, Pennsylvania and South Florida, Emerald Creek Capital has built a reputation as the industry leader in the alternative finance space. The firm provides bridge loans secured by commercial real estate in primary markets through both its domestic and offshore investment vehicles.",
  },
  {
    name: "Hosted",
    image: "/logos/hosted.png",
    websiteUrl: "https://www.shophosted.com",
    companyType: "Consumer goods",
    founder: "Meghan Jimena",
    founderUrl: "https://www.linkedin.com/in/meghan-jimena-976a7840/",
    description:
      "Hosted is a sustainable product development company specializing in compostable disposables and renewable facial tissue. We service mass retail and grocery customers across the US and are known for our modern design, compostable packaging and are certified women-owned/operated.",
  },
  {
    name: "We Are The Mighty",
    image: "/logos/we-are-the-mighty.png",
    websiteUrl: "https://www.wearethemighty.com",
    companyType: "Entertainment Providers",
    founder: "David Gale",
    founderUrl: "https://www.linkedin.com/in/dagale/",
    description:
      "Everyone’s got a mouth, and a healthy mouth is the gateway to a healthier you. So we strive to bring delight to your daily routine and help you guide good habits from morning refresh to bedtime brushing.",
  },
  {
    name: "Wink Coffee",
    image: "/logos/wink-coffee.png",
    websiteUrl: "https://winkcoffee.com",
    companyType: "Consumer goods",
    founder: "Jayson Rapaport",
    founderUrl: "https://www.linkedin.com/in/jayrap/",
    description:
      "Everyone’s got a mouth, and a healthy mouth is the gateway to a healthier you. So we strive to bring delight to your daily routine and help you guide good habits from morning refresh to bedtime brushing.",
  },
  {
    name: "Cleanup",
    image: "/logos/cleanup.png",
    websiteUrl: "https://www.cleanup.com",
    companyType: "Manufacturing",
    founder: "Matthew Wadiak",
    founderUrl: "https://www.linkedin.com/in/matthew-wadiak-9683976/",
    description:
      "We’re elevating the cleaning category and beyond with innovative, easy-to-use devices that just make it easy and satisfying to refill.  Our devices are meticulously engineered for performance and our formulas are powerful, yet safe.  Welcome to the future of cleaning..",
  },
  {
    name: "Seaweed Bath Co",
    image: "/logos/seaweed-bath-co.png",
    websiteUrl: "https://seaweedbathco.com",
    companyType: "Manufacturing",
    founder: "Adam Grossman",
    founderUrl: "https://www.linkedin.com/in/adam-grossman-189509222/",
    description:
      "We’re elevating the cleaning category and beyond with innovative, easy-to-use devices that just make it easy and satisfying to refill.  Our devices are meticulously engineered for performance and our formulas are powerful, yet safe.  Welcome to the future of cleaning..",
  },
  {
    name: "Recurrent",
    image: "/logos/recurrent.png",
    websiteUrl: "https://recurrent.io",
    companyType: "Online Audio and Video Media",
    founder: "Andrew Perlman",
    founderUrl: "https://www.linkedin.com/in/adam-grossman-189509222/",
    description:
      "Recurrent Ventures Inc. is an innovative digital media company that is challenging the media landscape with its proprietary approach. Its best-in-class brands like Popular Science, Domino, Outdoor Life, The Drive, Donut, Dwell, Task & Purpose and more, engage a combined audience of more than 60 million monthly visitors.",
  },
  {
    name: "No Cow",
    image: "/logos/no-cow.png",
    websiteUrl: "https://nocow.com",
    companyType: "Manufacturing",
    founder: "Daniel Katz",
    founderUrl: "https://www.linkedin.com/in/daniel-katz-1b922587/",
    description:
      "No Cow, is a foodtech company revolutionizing the nutrition industry using alternative, plant-based proteins. No Cow delivers better taste, AND better nutrition, using plants (not cows) as our foundation, and science and technology as our guides. We are developing the first plant-based, sustainable protein alternatives that are truly superior in every “whey.”",
  },
  {
    name: "Cibo Vita",
    image: "/logos/cibo-vita.png",
    websiteUrl: "https://cibovita.com",
    companyType: "Food and Beverage Services",
    founder: "Ahmet Celik",
    founderUrl: "https://www.linkedin.com/in/ahmet-celik-52247928/",
    description:
      "Cibo Vita’s products are featured on the shelves of supermarkets, warehouse clubs, major retail chains, specialty shops and c-stores across the nation. The company’s dedication to excellence has earned it numerous industry accolades, including the prestigious sofi™ and Nexty awards. In 2022, Emre Imamoglu was recognized with the Ernst & Young NJ Entrepreneur of the Year Award. ",
  },

  // ---------------------------------------------------------------------
  // Added from the updated portfolio list. Logo, website and sector are not
  // known yet — the grid renders a wordmark tile and hides the sector line
  // until they're filled in, so these display cleanly as-is.
  // ---------------------------------------------------------------------
  {
    name: "Natureza",
    image: "/logos/natureza.png",
    websiteUrl: "https://natureza.co",
    companyType: "Growth Equity",
  },
  {
    name: "Luminary Brands",
    image: "/logos/luminary-brands.png",
    // No public site found. Third-party listings describe a natural
    // beauty/personal-care company in Petaluma, CA — unverified, so the
    // sector is left blank rather than guessed.
    websiteUrl: "",
    companyType: "",
  },
  {
    name: "Incrediwear",
    image: "/logos/incrediwear.png",
    websiteUrl: "https://incrediwear.com",
    companyType: "Consumer goods",
  },
  {
    name: "Create",
    image: "/logos/create.png",
    websiteUrl: "https://trycreate.co",
    companyType: "Health & Wellness",
  },
  {
    name: "HealthyCell",
    image: "/logos/healthycell.png",
    websiteUrl: "https://www.healthycell.com",
    companyType: "Health & Wellness",
  },
  {
    // The company brands itself "Forest" with one R — matched to their own site.
    name: "The Forest Road Company",
    image: "/logos/forest-road.png",
    websiteUrl: "https://forestroad.com",
    companyType: "Investment & Advisory",
  },
  {
    name: "Borealis / Stilllife",
    image: "/logos/borealis.png",
    websiteUrl: "https://borealis.cool",
    companyType: "AI Infrastructure",
    founder: "Behrnt Schultz",
  },
];

export const Team = [
  // Operating team first, by seniority; advisors follow.
  {
    id: 1,
    name: "William Siegel",
    position: "Founder",
    bio: "Founder and Managing Director of Vital Force Capital. 30+ years investing; serves on multiple CPG boards. BA, Columbia; JD, NYU.",
    imageUrl: "https://vitalforceassets.s3.amazonaws.com/IMG_7541.jpg",
  },
  {
    id: 1,
    name: "Henri Francois",
    position: "Principal",
    bio: "Ex-tech founder backed by Jason Calacanis. CEO of Wink Coffee and founder of Reville, a strategic agency. Advisor across venture capital and private equity.",
    imageUrl: "/photos/Henri.jpg",
  },
  {
    id: 1,
    name: "Behrnt Schultz",
    position: "Associate",
    // Save the supplied headshot to public/photos/Behrnt-Schultz.jpg.
    // Until it exists the team cards fall back to an initials tile.
    imageUrl: "/photos/Behrnt-Schultz.jpg",
    bio: "Co-founder of Stilllife / Borealis and COO at Wink Coffee. Founder at Hulkz Solventless and Ovia Botanicals.",
  },
  {
    id: 1,
    name: "Ben Zises",
    position: "Advisor",
    bio: "Entrepreneur and investor; founding advisor and first investor at quip. Helps lead TriArch Real Estate Group. BA, Boston University; NYU Real Estate Finance & Investment certificate.",
    imageUrl: "https://vitalforceassets.s3.amazonaws.com/ben_super.jpeg",
  },
  {
    id: 1,
    name: "Mark Zurcher",
    position: "Advisor",
    bio: "Veteran CPG operator. Former CEO of Angie's Boomchickapop (sold to Conagra) and Ann's House of Nuts (sold to TreeHouse). 20+ years at Conagra and Kraft.",
    imageUrl:
      "https://vitalforceassets.s3.amazonaws.com/image_Mark-Zurcher_1517614515237-230x230.jpg",
  },
  {
    id: 1,
    name: "Adam Grossman",
    position: "Advisor",
    bio: "Co-founder, The Seaweed Bath Co. and Sea Calm Skin; co-founded Southern Turf Co. Experienced founder and operator. BA, UT Austin; MS Finance, University of Denver.",
    imageUrl: "https://vitalforceassets.s3.amazonaws.com/adam-grossman.jpg",
  },
];
